import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    employees: [],
    status: HTTP_STATUS.IDLE,
    deleteStatus: HTTP_STATUS.IDLE
}

export const fetchEmployeeByProduct = createAsyncThunk('employee/get-by-product', async (productId = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(`${BASE_URL}/api/Employee/get-employee-by-product/${productId}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const createEmployee = createAsyncThunk('employee/create', async ({ name, isSalesRef, employeeType }, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(`${BASE_URL}/api/Employee`, { name, isSalesRef, employeeType })
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const updateEmployee = createAsyncThunk('employee/update', async ({ id, name, isSalesRef, employeeType }, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(`${BASE_URL}/api/Employee/${id}`, { name, isSalesRef, employeeType })
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const deleteEmployee = createAsyncThunk('employee/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(`${BASE_URL}/api/Employee/${id}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchSalesRefByProduct = createAsyncThunk('employee/get-sales-reff/by-product', async (productId = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(`${BASE_URL}/api/Employee/get-sales-ref-by-product/${productId}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const Employee = createSlice({
    name: 'employee',
    initialState,
    reducers: {
        resetState: (state, action) => {
            return initialState;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchEmployeeByProduct.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchEmployeeByProduct.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.employees = action.payload
            })
            .addCase(fetchEmployeeByProduct.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(deleteEmployee.pending, (state, action) => {
                state.deleteStatus = HTTP_STATUS.LOADING
            })
            .addCase(deleteEmployee.fulfilled, (state, action) => {
                state.deleteStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(deleteEmployee.rejected, (state, action) => {
                state.deleteStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getEmployees = (state) => state.employee.employees;
export const getEmployeeStatus = (state) => state.employee.status;
export const getEmployeedeleteStatus = (state) => state.employee.deleteStatus;

export const employeeActions = Employee.actions

export default Employee.reducer
